import script from "./BlackBoxToolCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BlackBoxToolCard.vue?vue&type=script&setup=true&lang=js"

import "./BlackBoxToolCard.vue?vue&type=style&index=0&id=810da0a6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-810da0a6"]])

export default __exports__